<template>
  <section class="proposals-form">
    <embed-frame
      class="proposals-form-frame"
      endpoint="proposals/form"
      placeholder="Carregando..."
      :settings="embedSettings"
      :callbacks="embedCallbacks"
    />
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import EmbedFrame from '@sdk/views/Embed/Frame.vue';

  export default {
    name: 'ProposalsForm',
    components: {
      EmbedFrame,
    },
    computed: {
      ...mapState([
        'auth',
      ]),

      embedSettings() {
        return {
          proposals: {
            form: {
              id: this.$route.params.proposal_id,
              proposal_attempt: {
                id: this.$route.params.proposal_attempt_id,
              },

              store_id: this.$route.query.store_id,
              condition_ids: this.$route.query.condition_id,
              simulation_uuid: this.$route.query.simulation_uuid,
              customer_id: this.$route.query.customer_id,
            },
          },
        };
      },
      embedCallbacks() {
        return {
          'proposal:create': this.proposalSuccess,
          'proposal_attempt:create': this.proposalSuccess,
          'proposal_attempt:update': this.proposalSuccess,
        };
      },
    },
    methods: {
      proposalSuccess(data) {
        this.$router.push({
          name: 'proposals-read',
          params: {
            id: this.$route.params.proposal_id || (
              data.proposal_attempt
                ? data.proposal_attempt.proposal_id
                : data.complete_proposal.id
            ),
          },
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .proposals-form {
    padding: 0 var(--product--pwa--horizontal);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      padding: 0 var(--product--pwa--horizontal);
    }
  }
</style>
